import { IconButton } from '@mui/material';
import { COLOR_STROKE, Icons, TipPopover, usePopover } from 'shared';

export const BonusTip = () => {
  const { handleClose, handleOpen, open, anchorEl } = usePopover();

  return (
    <>
      <IconButton className="transparent" size="small" onClick={handleOpen}>
        <Icons.InfoCircle
          sx={{
            color: COLOR_STROKE,
          }}
        />
      </IconButton>
      <TipPopover open={open} onClose={handleClose} anchorEl={anchorEl}>
        Buy more CratD2C-Pre coins to level up!
      </TipPopover>
    </>
  );
};
